import { $fetch } from 'ofetch'
import { resolveApiBaseUrl, webApiBase } from '../utils/web-api.js'

export const useFetchForApi = async (url, options = {}) => {
	const runtimeConfig = useRuntimeConfig()

	let fetchOptions = { ...options }

	const accessToken = apiAccessToken()

	fetchOptions.headers = {
		...fetchOptions.headers,
		Accept: 'application/json',
		Authorization: `Bearer ${accessToken}`,
	}

	// Get tenant key if partner route.
	fetchOptions = usePartnerHeaders(fetchOptions)

	fetchOptions.baseURL = resolveApiBaseUrl(url, {
		apiUrl: runtimeConfig.public.API_URL,
		webApiUrl: webApiBase(runtimeConfig),
	})

	const targetUrl = augmentCarbarUrl(url, runtimeConfig.public.NODE_ENV)

	try {
		// $fetch executes the request directly and resolves to the parsed JSON response
		const data = await $fetch(targetUrl, fetchOptions)

		// Pass raw response data to formatter
		return getApiData(data, runtimeConfig.public.NODE_ENV)
	} catch (error) {
		const tempErr = getApiError(error)
		if (tempErr instanceof Error) {
			throw tempErr
		}
		throw error
	}
}
